module.exports = __webpack_public_path__ + "static/img/jiqiren_02.df27e4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jiqiren_02.png
// module id = D/SX
// module chunks = 0